module.exports = {"130402001":"火磨街道","130402002":"陵园路街道","130402003":"光明路街道","130402004":"滏东街道","130402005":"罗城头街道","130402006":"渚河路街道","130402007":"浴新南街道","130402008":"农林路街道","130402009":"贸东街道","130402010":"贸西街道","130402011":"盛和路街道","130402101":"北张庄镇","130402102":"河沙镇镇","130402200":"马庄乡","130402201":"南堡乡","130402202":"代召乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130402.json
// module id = 194
// module chunks = 0